import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: string;
}

export default function SEO({
  title = 'SnapVote - Make Better Decisions Together',
  description = 'Create engaging polls, gather meaningful insights, and make better decisions together. Join the community of curious minds and decision makers.',
  image = '/og-default.jpg',
  url = 'https://snapvote.ai',
  type = 'website'
}: SEOProps) {
  const siteTitle = 'SnapVote';
  const fullTitle = title === siteTitle ? title : title;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:site_name" content={siteTitle} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image.startsWith('/') ? `https://snapvote.ai${image}` : image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image.startsWith('/') ? `https://snapvote.ai${image}` : image} />
      <meta name="twitter:url" content={url} />
      
      {/* Additional Meta Tags */}
      <meta name="application-name" content={siteTitle} />
      <meta name="apple-mobile-web-app-title" content={siteTitle} />
      <meta name="theme-color" content="#2563eb" />
      <meta name="msapplication-TileColor" content="#2563eb" />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebApplication',
          name: siteTitle,
          description,
          url,
          applicationCategory: 'DecisionMakingApplication',
          operatingSystem: 'Web',
          offers: {
            '@type': 'Offer',
            price: '0',
            priceCurrency: 'USD'
          },
          datePublished: '2025-04-01',
          provider: {
            '@type': 'Organization',
            name: siteTitle,
            url
          }
        })}
      </script>
    </Helmet>
  );
}